import { Directive, ElementRef, Input, Output, EventEmitter, OnChanges, SimpleChanges, inject } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[porScrollTo]'
})
export class ScrollToDirective implements OnChanges {
    private readonly el = inject(ElementRef);

    @Input() porScrollTo!: boolean; // Trigger to scroll when set to true
    @Output() readonly scrollComplete: EventEmitter<void> = new EventEmitter<void>();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['porScrollTo'] && this.porScrollTo) {
            this.scrollToElement();
        }
    }

    private scrollToElement(): void {
        this.el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Emit the event after scrolling completes
        this.scrollComplete.emit();
    }
}
